<ng-container>
  <ng-template #noRefundable>
    <div class="cancel-policies-information">
      <mb-badge color="light" size="small" i18n="@@cancelpolicies_no_reembolsable"
        >No reembolsable</mb-badge
      >
      <mb-icon-text class="no-refundable">
        <mb-icon icon="cross"></mb-icon>
        <span i18n="@@cancelpolicies_no_podes_cancelar_ni_realizar_cambios"
          >No podés cancelar ni realizar cambios.</span
        >
      </mb-icon-text>
    </div>
  </ng-template>
  <div class="cancel-policies-information" *ngIf="refundable; else noRefundable">
    <mb-badge
      color="success"
      size="small"
      *ngIf="completelyRefundable"
      i18n="@@cancelpolicies_cancelacion_gratis"
      >Cancelación gratis</mb-badge
    >
    <mb-icon-text class="refundable">
      <mb-icon icon="check-simple"></mb-icon>
      <span
        *ngIf="isCvc"
        i18n="@@cancelpolicies_se_permite_la_cancelacion_o_cambio_con_cargo"
        >Se permite la cancelación o cambio con cargo.</span
      >
      <span *ngIf="!isCvc">
        <span i18n="@@cancelpolicies_antes_del_x_de"
          >Antes del {{ cancelation.date }} de
        </span>
        <span i18n="@@cancelpolicies_mounth">{cancelation.monthNumber, select,
          1 {ene}
          2 {feb}
          3 {mar}
          4 {abr}
          5 {may}
          6 {jun}
          7 {jul}
          8 {ago}
          9 {sept}
          10 {oct}
          11 {nov}
          12 {dic}
        }</span
        >&nbsp;
        <span i18n="@@cancelpolicies_de_x_inclusive"
          >de {{ cancelation.year }} inclusive.</span
        >
      </span>
    </mb-icon-text>
  </div>
</ng-container>
